import { useContext, useRef } from "react"
import { TableRowColumnIndexContex } from "../../../context/TableRowColumnIndexContex";
import { toast } from "react-toastify";


export default function AnchorFieldSelectedText(){
    const { savedRangeRef } = useContext(TableRowColumnIndexContex);
    const linkInputRef = useRef(null);
    
      function handleErrorMessage(message) {
        toast.error(message, {
          autoClose: 2000,
          position: "top-center",
        });
      }

    const restoreSelection = () => {
        const saved = savedRangeRef.current;
        if (!saved) return;

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(saved);
    };

    // Drag & Drop support for HREF input
    const handleLinkDrop = (e) => {
        e.preventDefault();
        const droppedText = e.dataTransfer.getData("text/plain");
        linkInputRef.current.innerText = droppedText;
    };
    const applyLink = () => {
        const href = linkInputRef.current.innerText.trim();
        if (!href) return;

        restoreSelection(); // restore selection first!

        const sel = window.getSelection();
        if (!sel.rangeCount) return;

        const range = sel.getRangeAt(0);
        const selected = range.toString();

        if (!selected.trim()) {
        handleErrorMessage("Select some text first.");
        return;
        }

        const a = document.createElement("a");
        a.href = href;
        a.textContent = selected;

        // Make it visible
        a.style.color = "blue";
        a.style.textDecoration = "underline";
        a.target = "_blank"; // optional

        range.deleteContents();
        range.insertNode(a);

        range.setStartAfter(a);
        range.setEndAfter(a);
        sel.removeAllRanges();
        sel.addRange(range);

        savedRangeRef.current = null; // remove saved selection
    };

    return <div>
        <label>Link</label>

        <div
          ref={linkInputRef}
          contentEditable
          suppressContentEditableWarning
          onDrop={handleLinkDrop}
          onDragOver={(e) => e.preventDefault()}
          style={{
            border: "1px solid #444",
            padding: "8px",
            minHeight: "20px",
            borderRadius: "4px",
            marginTop: "6px",
          }}
        ></div>

        <button
          onClick={applyLink}
          style={{
            marginTop: "10px",
            padding: "4px 8px",
            background: "#4f46e5",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Apply
        </button>
    </div>
}